/* ABT sepet davranışları: kargo eşiği şeridi ve çekmecedeki öneri satırının
   hızlı sepete ekle butonu.

   Çekmece AJAX ile yeniden render edildiği için içindeki script etiketleri
   çalışmaz. Bu dosya theme.liquid'den bir kez yüklenir ve document
   seviyesinde dinler, böylece sepet sayfası ve çekmece aynı koddan beslenir.
   Aynı sebeple buton dinleyicisi de delegasyonla kurulur. */
(() => {
  if (window.__abtSepetKurulu) return;
  window.__abtSepetKurulu = true;

  const para = (kurus) =>
    '₺' + (kurus / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const yaz = (sepet) => {
    const toplam = sepet.total_price || 0;
    const bos = (sepet.item_count || 0) === 0;

    document.querySelectorAll('[data-abt-kargo]').forEach((kok) => {
      const esik = Number(kok.dataset.esik) || 0;
      const firma = kok.dataset.kargoAdi || '';
      const metin = kok.querySelector('[data-kargo-metin]');

      kok.classList.toggle('abt-kargo--gizli', bos);
      if (bos || !metin) return;

      const oran = esik > 0 ? Math.min(100, Math.round((toplam * 100) / esik)) : 0;
      kok.style.setProperty('--abt-kargo-oran', oran + '%');
      kok.classList.toggle('abt-kargo--tamam', toplam >= esik);

      metin.innerHTML =
        toplam >= esik
          ? kok.dataset.metinTamam || ''
          : (kok.dataset.metinKalan || '').replace('@@', '<b>' + para(esik - toplam) + '</b>');
    });
  };

  /* Tema rozeti kendi CartLinesUpdateEvent akışını bekliyor ve o event
     promise taşıyor. Düz CustomEvent göndermek rozeti güncellemiyordu,
     sayıyı doğrudan yazıyoruz. */
  const rozetYaz = (adet) => {
    document.querySelectorAll('.cart-bubble__text-count').forEach((el) => {
      el.textContent = adet < 100 ? String(adet) : '';
    });
    document.querySelectorAll('.cart-bubble').forEach((el) => {
      el.classList.toggle('visually-hidden', adet === 0);
    });
  };

  const tazele = () =>
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then(yaz)
      .catch(() => {});

  document.addEventListener('shopify:cart:lines-update', tazele);

  /* ————— Öneri satırında hızlı sepete ekle —————
     Horizon'un quick-add bileşeni çekmecede tepki vermiyor, product-card
     bağlamı bekliyor. Tek varyantlı ürünü doğrudan ekliyoruz; çekmece
     içeriği section render ile tazeleniyor, sayfa yenilenmiyor. */

  const cekmeceyiTazele = async () => {
    const kap = document.getElementById('shopify-section-cart-drawer-section');
    if (!kap) return;

    const html = await fetch('/?section_id=cart-drawer-section')
      .then((r) => r.text())
      .catch(() => null);
    if (!html) return;

    const taze = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('shopify-section-cart-drawer-section');
    if (!taze) return;

    /* Çekmecenin açık kalması için dialog'un kendisi değil yalnız içeriği
       değişir; theme-drawer'ın open durumu korunur. */
    const eskiIc = kap.querySelector('cart-items-component');
    const yeniIc = taze.querySelector('cart-items-component');
    if (eskiIc && yeniIc) eskiIc.replaceWith(yeniIc);
    else kap.replaceChildren(...taze.childNodes);
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target instanceof Element ? e.target.closest('[data-abt-oneri-ekle]') : null;
    if (!btn) return;

    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');

    try {
      const yanit = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.abtOneriEkle), quantity: 1 }] }),
      });
      if (!yanit.ok) throw new Error('ekleme basarisiz');

      btn.classList.add('is-eklendi');
      await cekmeceyiTazele();
      const sepet = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      yaz(sepet);
      rozetYaz(sepet.item_count || 0);
    } catch {
      btn.removeAttribute('aria-busy');
    }
  });
})();
